<template>
  <ul :style="{'transform' : 'translateY('+ (200 + (10 * scroll)) +'vh) rotate(-90deg)' }" v-if='kirby.site.strings'>
    <li v-for="i in 18"  :key="i" v-once>
      <time>{{formattedDate(kirby.site.strings.startdate, 'd.m')}}-<br>{{formattedDate(kirby.site.strings.enddate, 'd.m.yyyy')}}</time>
      <big>{{kirby.site.strings.title}}</big>
    </li>
  </ul>
</template>

<style scoped>

  ul {
    white-space: nowrap;
    font-size: 2.25rem;
    line-height: 0.8125em;
    letter-spacing: -0.075em;
    will-change: transform;
  }

  li {
    width: 9.45em;
    display: inline-block;
  }

  time {
    font-size: inherit;
    line-height: inherit;
    display: inline-block;
    text-transform: uppercase;
    vertical-align: bottom;
    text-align: right;
    padding-right: 0.2em;
  }

  big {
    width: 9.45em;
    white-space: normal;
    line-height: inherit;
    font-size: inherit;
    text-transform: uppercase;
    display: inline-block;
    vertical-align: bottom;
  }
</style>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['scroll'],
}
</script>
